import { Observable } from '@apollo/client';
function customOnlySequence(operation, _forward, sequenceConfig, handler) {
  return new Observable(observer => {
    handler.fetchCustom(operation, null, sequenceConfig, null).then(customFetchResponse => {
      const queryResponse = handler.responseTransformer(operation, null, sequenceConfig, null, customFetchResponse);
      observer.next({
        data: queryResponse
      });
      observer.complete();
    }).catch(err => {
      observer.error(err);
    });
  });
}
export { customOnlySequence };